/**
 * Phase 37 — "★ 5 proven only": the one-line mirror, on a rule card that
 * creates a kind of drop (scaling, cool-down, experiment), of what those
 * drops send — their text mix. Read-only here — the mix is set once on
 * Creative › Text ranking › Config; the ⓘ says so.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { Star } from 'lucide-react';
import { describeMix, type DropGenTextMix } from '@trafficpulse/shared';

import { HintDot } from '@/components/ui';

interface Props {
  /** The kind's mix; absent or without a proven text = nothing to say. */
  mix?: DropGenTextMix | null;
  /** The drops in question, for the ⓘ ("The scaled drops"). */
  what?: string;
}

export const ProvenTag: FC<Props> = ({ mix, what = 'these drops' }) => {
  if (!mix || mix.proven <= 0) return null;
  return (
    <span className="inline-flex items-center gap-1 text-success" data-testid="proven-tag">
      <Star className="h-3 w-3" aria-hidden />
      {describeMix(mix)} texts
      <HintDot label={`${what} send ${describeMix(mix)} texts: ${mix.proven} taken from the ranking's reuse pool (texts that already performed, no AI call)${mix.ai > 0 ? ` and ${mix.ai} written fresh by the AI` : ''}. If the pool has fewer proven texts than that, the missing ones become AI texts automatically. Set on Creative › Text ranking › Config; a draft that becomes one of these mid-day gets its proven texts added in front of its own.`} />
    </span>
  );
};
